module.exports = __webpack_public_path__ + "static/media/deny.45331286.mp3";